"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfGetter = void 0;
var AppConfig_1 = require("./AppConfig");
var DataContainer_1 = require("./DataContainer");
var Message_1 = require("./Message");
var ConfGetter = (function () {
    function ConfGetter() {
        this.getConf = function () {
            return $.ajax({
                url: "./" + AppConfig_1.AppConfig.APP_CONFIG.confAPI + ".json",
                type: 'GET',
                headers: {
                    'x-api-key': AppConfig_1.AppConfig.APP_CONFIG.APIKey,
                    'Content-Type': 'application/json',
                },
            })
                .done(function (data) {
                DataContainer_1.DataContainer.config = data.config;
                Message_1.Message.log(data);
            })
                .fail(function (data) {
                Message_1.Message.showMessage(Message_1.Message.LOAD_CONF_ERROR);
            })
                .always(function (data) {
            });
        };
    }
    return ConfGetter;
}());
exports.ConfGetter = ConfGetter;
